import { render, staticRenderFns } from "./FormAddIndicator.vue?vue&type=template&id=472222fe&"
import script from "./FormAddIndicator.vue?vue&type=script&lang=js&"
export * from "./FormAddIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports